module.exports = __webpack_public_path__ + "static/img/logo-mini-white.8a1118e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-mini-white.png
// module id = w7TW
// module chunks = 11